import React, { useEffect, useState, useImperativeHandle } from 'react';
import { Table, Empty, Spin, Modal, message, Pagination } from 'antd';
import { deleteTaskById, getTaskList, exportTaskList } from '../../../../actions/majorProjects';
import {applicationName, permissionCheck} from '../../../../utils'
import eventProxy from "../../../../utils/eventProxy";
import Scrollbars from 'react-custom-scrollbars';
import position from '../../images/position.png';
import time from '../../images/time.png';


//任务列表页面
const { confirm } = Modal
const TaskList = (props) => {

  const [current, setCurrent] = useState(1);
  const [taskData, setTaskData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(8);
  
  useImperativeHandle(props.refs, () => ({
    searchFirst: search
  }))

  const searchFirst = (current) => {
    console.log(current)
    setCurrent(current);
  }

  useEffect(() => {
    search(current);
  }, [current])
  const findUrlData = (url) => {
    let sons;
    let name;
    let stopFind = false;
    let find = (data, level, levelOneBrothers, levelOneName) => {
        if (stopFind)
            return;
        if ((!data.sons || data.sons.length === 0) && (!data.float_ || data.float_.length === 0)) {
            if (data.path === url) {
                sons = levelOneBrothers;
                name = levelOneName;
                stopFind = true;
            }
            return;
        }
        let tempSons = data.float_;
        if (!tempSons || tempSons.length === 0) {
            tempSons = data.sons;
        }
        if (stopFind)
            return;
        tempSons && tempSons.map(item => {
            if (stopFind)
                return;
            let tempItemSons = item.float_;
            if (!tempItemSons || tempItemSons.length === 0) {
                tempItemSons = item.sons;
            }
            if (level == 0) {//取第一级的信息
                find(item, level + 1, tempItemSons, item.name);
            } else {
                find(item, level + 1, levelOneBrothers, levelOneName);
            }
        })
    };
    find({sons: props.navigateData}, 0, null, null);
    return {stopFind, sons, name};
};


  const goTaskDetail = (id) => {
   
            let {stopFind, sons, name} = findUrlData('/newsActivityIndex/newsActivityIndex');
            if (stopFind) {
                props.shrinNavigateStauts();
                props.updateNavigateLevel2Data(name, sons);
                window.location.hash = '/newsActivityIndex/newsActivityIndex';
                setTimeout(() => {
                  eventProxy.trigger('seeTask',`${id}`)
                },10)
            }
    
   // window.location.href = `#/newsActivityIndex/newsActivityIndex/interviewId/${id}/view`;

  }

  const goEditTask = (record) => {
   
    let {stopFind, sons, name} = findUrlData('/newsActivityIndex/newsActivityIndex');
    if (stopFind) {
        props.shrinNavigateStauts();
        props.updateNavigateLevel2Data(name, sons);
        window.location.hash = '/newsActivityIndex/newsActivityIndex';
        setTimeout(() => {
          eventProxy.trigger('editTask',`${record.id}`)
        },10)
    }
    //window.location.href = `#/newsActivityIndex/newsActivityIndex/interviewId/${record.id}/update`;
  }

  const columns = [
      {
          key: 'title',
          title: '名称',
          dataIndex: 'title',
          render: (text, record) => (<div className="column-title" style={{
              cursor: 'pointer',
              width: '300px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'contents;'
          }} onClick={() => goTaskDetail(record.id)}>{text}</div>)
      },
      {
          key: 'place',
          title: '位置',
          dataIndex: 'place',

          render: (text) => <div className="column-place" style={{
              width: '300px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block'
          }}><img src={position} alt=""/><span>{text}</span></div>
      },
    {
      key: 'interviewDate',
      title: '活动时间',
      dataIndex: 'interviewDate',
      width: '15%',
      render: (text) => <div className="column-interviewDate"><img src={time} alt="" /><span>{text}</span></div>

    },
    {
      key: 'status',
      title: '状态',
      dataIndex: 'status',
      width: '10%',
      render:(value, row, index)=>{
        return formateStatus(value,row);
    },
    },
    {
      key: 'action',
      title: '操作',
      width: '15%',
      render: (text, record) => {
        let isOpAuth = permissionCheck("pms:newsActiviti:edit");

        let isEditAuth = (record.status !== 4);//已发布
        let isDeleteAuth = (record.status === 1);//如果是未领取则可以删除

        let activityTime;//活动时间
        if(record.endDate){
            activityTime=record.endDate;
        }else{
            activityTime=record.interviewEndDate?record.interviewEndDate:0;//活动时间
        }

        let nowDate=new Date().getTime();//当前时间
        let statusName;
        if((record.status===1) && activityTime && (new Date(activityTime).getTime()<nowDate)){
            statusName='已超期'
        }
        return(
          <div style={{color:'#576184',fontFamily: 'MicrosoftYaHei-Bold',
                            fontSize: '15px',fontWeight: 'bold'}}>
                            {(isOpAuth&&isEditAuth&&(statusName!=='已超期'))?<span style={{ marginRight: 10, cursor: 'pointer'}} onClick={() => goEditTask(record)}>修改</span> :""}
                            <span style={{ cursor: 'pointer'}} onClick={() => deleteTask(record.id)}>移除</span>
                           {/* {isDeleteAuth&&permissionCheck("pms:newsActiviti:delete")?
                               <span style={{ cursor: 'pointer'}} onClick={() => deleteTask(record.id)}>移除</span>:""}*/}
                        </div>
        )
      }
    },
  ];

  const formateStatus = (value,row) => {

    let activityTime;//活动时间
    if(row.endDate){
        activityTime=row.endDate;
    }else{
        activityTime=row.interviewEndDate?row.interviewEndDate:0;//活动时间
    }
    let nowDate=new Date().getTime();//当前时间
     if(value==1){
         let statusName = "未领取";
         if(activityTime){
             statusName=new Date(activityTime.replace(/-/g,"/")).getTime()<nowDate?'已超期':'未领取';
         }
         return <div className={"unget_status"}>{statusName}</div>
     }else if(value==2){
         return <div className={"recieve_status"}>进行中</div>
     }else if(value==3){
         return <div className={"submitted_status"}>已提交</div>
     }else if(value==4){
         return <div className={"publish_status"}>已完成</div>
     }
}

  const deleteTask = (id) => {
    confirm({
      className: 'delete_dialog',
      title: '提示',
      content: '确定移除此任务？',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        let param = {
          interviewEventId: props.id,
          interviewId: id

        }
        deleteTaskById(param, function (res) {
          if (res.status === 200) {
            message.success('移除成功！');
            search(1)
            setCurrent(1);
          } 
        })
      },
      onCancel() {
      },
    });
  }

  const search = (current) => {
    let formData = {
      start: current,
      size: 8,
      id: props.id, ///项目id
    }
    setLoading(true)
    getTaskList(formData, function (res) {
      if (res.code === 0) {
        let data= [];
        res.data && res.data.length > 0 && res.data.map((item) => data.push(item.interview));
        setTaskData(data);
        setTotal(res.count);
        setLoading(false);
      }
    })
  }

  const changePage = (page) => {
    setCurrent(page);
  }

  const exportList = () => {
    const headers = {
      "Pragma": 'no-cache',
      'Cache-Control': 'no-cache',
      'Content-Type': ' application/x-www-form-urlencoded; charset=UTF-8',
    };
    if (taskData && taskData.length > 0) {
      fetch("/cm-sites-" + applicationName() + `/excelExport/interviewEvent/interviews?interviewEventId=${props.id}`, {
        method: 'GET',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        responseType: 'blob'
      }).then(response => response.blob().then(blob => {
        var alink = document.createElement('a');
        alink.style.display = 'none'
        alink.href = window.URL.createObjectURL(blob);
        alink.download = decodeURIComponent(response.headers.get('Content-Disposition').split(';filename=')[1]);   // 设置文件名
        document.body.appendChild(alink)
        alink.click();
        URL.revokeObjectURL(alink.href) // 释放URL 对象
        document.body.removeChild(alink)
      })).catch((error) => {
        alert(error)
      })
    }
  }

  return (
    <div className="taskList">
      {
        loading ? <Spin className="loading" /> : 
       (taskData.length === 0 ? <Empty className="noData" /> :
       <>
        <div className="taskList-content">
        <Scrollbars style={{ height: 440}}>
        <Table
            className="task-table"
            columns={columns}
            dataSource={taskData}
            rowKey={record => record.id} 
            pagination={false}
          />
        </Scrollbars>
          <Pagination
          style={{ textAlign: 'right', padding:'10px'}}
            current={current}
            pageSize={pageSize}
            total={total}
            onChange={changePage}
          />
        </div>
          <div className="footer">
          <span onClick={exportList}>导出列表</span>
        </div>
        </>
        )
      }
    </div>
  )
}

export default TaskList



